const thousandSeparator = (number) => {
  const n = Number(number || 0)
  return `${Number(Math.abs(n)).toLocaleString(undefined)}${n >= 0 ? "" : "-"} ت`
}

export default thousandSeparator